import Navbar from "./layout/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "./layout/Footer";
import Container from "@mui/material/Container";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import ChatWidget from "./customer/chat/ChatWidget";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  loadProfileAsync,
  setUserProfile,
  setLoading,
  refreshProfileAsync,
  setStatusProfileUpdateFirstTime,
} from "../services/profile/profileSlice";
import PageDriver from "./others/PageDriver";
import Profile from "./profile/Profile";
import ResultError from "../components/alert/ResultError";
import {
  getArchiveRequestAsync,
  getRequestAsync,
  getRequestUnRatedAsync,
  getUserBannerAsync,
} from "../services/request/requestSlice";
import ErrorLoadProfile from "./others/ErrorLoadProfile";
import { useState } from "react";
import { loadAddressAsync } from "../services/address/addressSlice";
import { collection, doc, onSnapshot } from "firebase/firestore";
import { db } from "../config/firebase-config"; // Adjust the path to your firebase.js file
import { UpdateRequestAfterNotifyAsync } from "../services/request/requestSlice";
import {
  NoIndexPage,
  IndexPage,
  checkStorePage,
  checkUserIsSeller,
  checkUserIsCustomer,
  checkUserIsDriver,
  checkFindProfileUser,
  checkFindStoreForSeller,
  sellerIsDisabled,
  showMainPageStore,
  checkFindProfileForWholeUser,
  checkUserIsNotGuest,
} from "../utils/helpers";
import {
  loadAllAttributesAsync,
  loadDeliveryOptionsAsync,
  loadStorePageAsync,
  setProducts,
} from "../services/store/storeSlice";
import ButtonCart from "../components/store/cart/ButtonCart";
import { allLinks } from "../utils/helpers";
import {
  getBusinessTypesAsync,
  getSellerReportAsync,
  getStoreAsync,
} from "../services/seller/sellerSlice";
import SellerInfo from "./seller/create_store/SellerInfo";
import SellerStatus from "./seller/create_store/SellerStatus";
import {
  GetOrderByIdAsync,
  GetOrderStoreAsync,
  GetUserOrdersAsync,
} from "../services/order/orderSlice";
import SupportWidget from "./seller/support/SupportWidget";
import { signInAnonymously } from "firebase/auth";
import { auth as authGuest } from "../config/firebase-config";
import  store  from "../stores/store"; // Import store to access state

export default function Base() {
  const {
    isLoading,
    userProfile,
    statusProfile,
    statusProfileUpdateFirstTime,
  } = useSelector((state) => state.profile);
  const { user } = useSelector((state) => state.auth);
  const auth = useSelector((state) => state.auth);
  const dynamicState = useSelector((state) => state.dynamicConfig);
  const { status, error } = useSelector((state) => state.request);
  const { sellerInfo, statusSeller, sellerReport } = useSelector(
    (state) => state.seller
  );
  const { search_term, CategorySelected } = useSelector((state) => state.store);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const handleMsg = (val) => setMsg(val);
  // const loginAsGuest = async () => {
  //   try {
  //     await signInAnonymously(authGuest);
  //   } catch (err) {
  //     console.error("Anonymous sign-in error:", err);
  //   }
  // };
  // get the current path 
  // const currentPath = window.location.pathname;
  // // check if the current path starts with /product 
  // const isProductPage = currentPath.startsWith("/product");


  useEffect(() => {
    if (checkUserIsNotGuest(user)) {
      // Only load profile if not already loading or loaded
      if (statusProfile === 'idle') {
        dispatch(setLoading({ isLoading: true }));
        dispatch(loadProfileAsync({ auth, dynamicState }));
      }
      // NoIndexPage(); // add no indexing for SEO
    } else {
      // loginAsGuest(); // login as Guest
      dispatch(setUserProfile({ userProfile: null }));
      // IndexPage(); // add indexing for SEO
    }
  }, [dispatch, user, statusProfile]);
  

  //effect after load profile and load all data
  useEffect(() => {
    const fetchData = async () => {
     
      if (user)   {

        // ** api for seller + e-commerce  without auth  ** //
        if(checkStorePage() || checkUserIsSeller(userProfile)){
          // Only load if data doesn't exist to prevent multiple calls
          const storeState = store.getState().store;
          
          if (!storeState.attributesLoaded && storeState.categories.length === 0 && !storeState.attributesLoading) {
            dispatch(loadAllAttributesAsync({ auth, dynamicState }));
          }

          // ** load delivery options  ** //
          if (!storeState.deliveryOptions && !storeState.deliveryOptionsLoading) {
            dispatch(loadDeliveryOptionsAsync({ auth, dynamicState }));
          }
  
          // ** load store page  ** //
          if (!storeState.storePage && !storeState.storePageLoading) {
            dispatch(loadStorePageAsync({ auth, dynamicState }));
          }
        }else{ // request loaded for customer request page
          const globalState = store.getState().global;
          if (!globalState.bannerLoaded && !globalState.bannerLoading) {
            dispatch(getUserBannerAsync({ auth, dynamicState }));
          }
        }
       
        // load profile
        if (
          statusProfile === "succeeded" ||
          statusProfileUpdateFirstTime === "succeeded"
        ) {
          if (!checkFindProfileUser(userProfile)) {
            navigate(`/${allLinks[10]}`, { replace: true }); // finish account creation first
          } else if (checkFindProfileForWholeUser(userProfile)) {
            // check user is customer or seller
    
            // get all address - only for authenticated users
            if (checkUserIsNotGuest(user)) {
              dispatch(loadAddressAsync({ auth, dynamicState }));
            }

            if (checkUserIsCustomer(userProfile)) {
              if (statusProfileUpdateFirstTime === "succeeded") {
                const redirect = localStorage.getItem("redirect");
                localStorage.removeItem("redirect");
                dispatch(setStatusProfileUpdateFirstTime("idle"));
                navigate(redirect || "/", { replace: true });
              }


              // get request review invoked once only - only for authenticated users
              if (checkUserIsNotGuest(user)) {
                !checkStorePage()  &&  dispatch(getRequestUnRatedAsync({ auth, dynamicState }));
              }

              // get request active
              !checkStorePage()  && dispatch(getRequestAsync({ auth, dynamicState }));

              // get archive active
              !checkStorePage()  &&  dispatch(getArchiveRequestAsync({ auth, dynamicState }));

              // ** load order page  ** //
              checkStorePage()  &&  dispatch(GetUserOrdersAsync({ auth, dynamicState }));
            }

            if (checkUserIsSeller(userProfile)) {
              // reset product
               dispatch(setProducts([]));

              // get store information
              await dispatch(getStoreAsync({ auth, dynamicState }));

              // get all get Business Type for add seller
              await dispatch(getBusinessTypesAsync({ auth, dynamicState }));
              
              // For first-time profile creation, navigate to store creation immediately
              if (statusProfileUpdateFirstTime === "succeeded") {
                navigate(`/${allLinks[13]}`);
              }
            }
          }
        }

      }
      
    };

    fetchData(); // Call async function
  }, [statusProfile, statusProfileUpdateFirstTime, dispatch, navigate, userProfile, allLinks]);

  useEffect(() => {
    if (statusSeller === "succeeded") {
      // check user find  store
      if (checkUserIsSeller(userProfile) &&  !checkFindStoreForSeller(sellerInfo)) {
        // redirect page
        navigate(`/${allLinks[13]}`);
      } else {
        if (!sellerReport?.reports)
          dispatch(getSellerReportAsync({ auth, dynamicState })); // get seller report

        // invoked all orders seller
        let data = {
          store_id: sellerInfo?.id,
          limit: 20,
          offset: 0,
          status: "all",
        };
        dispatch(GetOrderStoreAsync({ auth, dynamicState, data }));
      }
    }
    
    // Handle case where seller doesn't have a store yet (404 response)
    if (statusSeller === "failed" && checkUserIsSeller(userProfile)) {
      // redirect to store creation page when store doesn't exist
      navigate(`/${allLinks[13]}`);
    }
  }, [statusSeller, dispatch, userProfile, navigate, sellerInfo, allLinks]);

  // effect for all requests + archive request
  useEffect(() => {
    if (status === "failed") handleMsg(error);
  }, [status, dispatch]);

  //check find any change in the request,profile
  useEffect(() => {
    if (checkUserIsNotGuest(user)) {
      const unsubscribe = onSnapshot(
        collection(db, `/users/${user?.uid}/digest_next`),
        (snapshot) => {
          const newData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // check profile
          if (
            localStorage.getItem("profile_update_id") !==
            newData[0]?.profile_update_id
          ) {
            if (localStorage.getItem("profile_update_id") !== null)
              dispatch(refreshProfileAsync({ auth, dynamicState }));

            localStorage.setItem(
              "profile_update_id",
              newData[0]?.profile_update_id
            );
          }

          // check request
          if (newData.length > 0) {
            if (
              !localStorage.getItem("request_update_id") &&
              newData[0]?.request_update_id !== undefined
            ) {
              localStorage.setItem(
                "request_update_id",
                newData[0]?.request_update_id
              );
              return;
            }

            if (
              newData[0]?.event === "new_offer_received" ||
              newData[0]?.event === "offer_cancelled" ||
              newData[0]?.event === "status_updated_by_driver"
            ) {
              // get the request id
              const req_id = newData[0]?.requestId;

              if (
                req_id !== null &&
                localStorage.getItem("request_update_id") !==
                  newData[0]?.request_update_id
              ) {
                localStorage.setItem(
                  "request_update_id",
                  newData[0]?.request_update_id
                );
                dispatch(
                  UpdateRequestAfterNotifyAsync({ auth, dynamicState, req_id })
                );
              }
            }
          }
        }
      );
      //  Cleanup listener on unmount
      return () => unsubscribe();
    }
  }, [dispatch, user]);

  //check find any change in the order
  useEffect(() => {
    if (checkUserIsNotGuest(user)) {
      const orderDigestDocRef = doc(
        db,
        "users",
        user.uid,
        "digest_next",
        "order_digest_doc"
      );
      const unsubscribe = onSnapshot(orderDigestDocRef, (docSnapshot) => {
        const data = { id: docSnapshot.id, ...docSnapshot.data() };

        // check profile
        if (localStorage.getItem("order_update_id") !== data?.order_update_id) {
          if (
            localStorage.getItem("order_update_id") !== null &&
            data?.order_id
          ) {
            let order_id = data?.order_id;
            dispatch(GetOrderByIdAsync({ auth, dynamicState, order_id }));
          }

          localStorage.setItem("order_update_id", data?.order_update_id);
        }
      });

      //  Cleanup listener on unmount
      return () => unsubscribe();
    }
  }, [dispatch, user]);

  return (
    <>
      {(isLoading || (checkUserIsNotGuest(user) && (statusProfile === 'loading' || statusProfile === 'idle'))) ? (
        <CircularProgress className="full-preloader-position" />
      ) : (
        <Box>
          {statusProfile === "failed" && <ErrorLoadProfile />}

          {checkUserIsDriver(userProfile) && <PageDriver />}

          {(checkUserIsNotGuest(user) || userProfile !== null) && (statusProfile === "succeeded" || statusProfileUpdateFirstTime === "succeeded") && (
            <>
              {!checkFindProfileUser(userProfile) && <Profile />}

              {(statusSeller === "succeeded" || 
                (statusSeller === "failed" && checkUserIsSeller(userProfile))) &&
                checkUserIsSeller(userProfile) &&
                (!checkFindStoreForSeller(sellerInfo) ||
                  sellerIsDisabled(sellerInfo)) && (
                  <>
                    <SellerStatus sellerInfo={sellerInfo} />
                    <SellerInfo />
                  </>
              )}

              {checkFindProfileUser(userProfile) &&
                (checkUserIsCustomer(userProfile) ||
                  (checkUserIsSeller(userProfile) &&
                    checkFindStoreForSeller(sellerInfo) &&
                    !sellerIsDisabled(sellerInfo))) && (
                  <Box>
                    <Navbar />
                    {/* {isProductPage && (
                        <p> hello testing under nav</p>
                    )} */}
                        
                    <Container
                      className={
                        (showMainPageStore(CategorySelected, search_term) &&
                        checkUserIsCustomer(userProfile) &&
                        checkStorePage())
                          ? "padding-outlet-slider-shop page_size"
                          : "padding-outlet page_size"
                      }
                    >
                      {checkUserIsSeller(userProfile) && (
                        <SellerStatus sellerInfo={sellerInfo} />
                      )}
                      <Outlet />
                    </Container>
                    <ResultError />
                    {checkStorePage() && checkUserIsCustomer(userProfile) && (
                      <ButtonCart />
                    )}
                    {!checkStorePage() && checkUserIsCustomer(userProfile) && (
                      <ChatWidget />
                    )}
                    {checkUserIsSeller(userProfile) && <SupportWidget />}
                    <Footer />
                  </Box>
                )}
            </>
          )}

          {!checkUserIsNotGuest(user) && userProfile===null && (
            <>
              <Box>
                <Navbar />
                <Container
                  className={
                    (showMainPageStore(CategorySelected, search_term) &&
                    checkStorePage())
                      ? "padding-outlet-slider-shop page_size"
                      : "padding-outlet page_size"
                  }
                >
                  <Outlet />
                </Container>
                <ResultError />
                {checkStorePage() && (
                  <ButtonCart />
                )}
                {!checkStorePage()  && (
                  <ChatWidget />
                )}
            
                <Footer />
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
}
